import { createContext, useContext } from 'react';
import type { GoTrueClient, Session } from '@supabase/auth-js';

/** The Supabase Auth client; the app uses no other Supabase service. */
export type AuthApi = GoTrueClient;

export interface AuthState {
  /** Current session, or null when signed out. */
  readonly session: Session | null;
  /** True until the initial session lookup settles; render nothing gated on auth before then. */
  readonly initializing: boolean;
  /** True after a password-recovery landing until the password is updated. */
  readonly recovering: boolean;
  /** Auth actions (sign in/up/out, reset, update) on the underlying client. */
  readonly auth: AuthApi;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const state = useContext(AuthContext);
  if (state === null) {
    throw new Error('useAuth requires an <AuthProvider> ancestor');
  }
  return state;
}
